import Vue from 'vue'
import VueRouter from 'vue-router'
import RankList from '@/views/RankList.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'RankList',
    component: RankList
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
